var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.messages.length
    ? _c("ValidationErrors", {
        staticClass: "orphan-assets-warnings",
        attrs: { errors: _vm.messages },
        scopedSlots: _vm._u(
          [
            {
              key: "action",
              fn: function(ref) {
                var index = ref.index
                return [
                  _c(
                    "BaseButton",
                    {
                      staticClass: "mx-10",
                      attrs: {
                        small: "",
                        dark: "",
                        outline: "",
                        "min-width": "80px"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleLink(index)
                        }
                      }
                    },
                    [_vm._v(" Vincular à base ")]
                  )
                ]
              }
            }
          ],
          null,
          false,
          3755017080
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }